export interface AdminDomain {
  id: number;
  uuid: string;
  name: string;
  status: string;
  createdAt?: string;
}

export interface AdminDomainQrTemplate {
  uuid: string;
  name: string;
  isDomainDefault?: boolean;
}

export interface AdminDomainDetail extends AdminDomain {
  homePageUrl?: string;
  notFoundPageUrl?: string;
  createdDate?: string;
  qrTemplates: AdminDomainQrTemplate[];
}

export interface AdminDomainsListMeta {
  currentPage: number;
  perPage: number;
  total: number;
  totalPages: number;
}

export interface AdminDomainsListResponse {
  data: AdminDomain[];
  meta: AdminDomainsListMeta;
}

export interface UpdateDomainSettingsPayload {
  status?: string;
  homePageUrl?: string;
  notFoundPageUrl?: string;
  defaultQrTemplateUuid?: string;
}

export const DEFAULT_ADMIN_DOMAINS_CURRENT_PAGE = 1;
export const DEFAULT_ADMIN_DOMAINS_PER_PAGE = 25;
export const ADMIN_DOMAINS_PAGE_SIZE_OPTIONS = [25, 50, 100] as const;
